function customFancyboxInit(fancyboxLinkNode) {
	if (fancyboxLinkNode === undefined || !fancyboxLinkNode) {
        console.error('customFancyboxInit: invalid fancyboxLinkNode ', fancyboxLinkNode);
        return false;
    }
	let fancyboxContentId = fancyboxLinkNode.getAttribute("href");
	if (!fancyboxContentId || fancyboxContentId.length === 0) {
		console.error('customFancyboxInit: invalid fancyboxContentId from href attribute ', fancyboxLinkNode);
		return false;
	}
	var ps = null;

	fancyboxLinkNode.addEventListener('click', function(e) {
		e.preventDefault();
		const fancybox = new Fancybox([{
			src  : fancyboxContentId,
			type : 'inline',
		}],{
			mainClass: "my-custom-fancybox",
			closeButton: false,
			on: {
				done: (fancybox, slide) => {
					ps = $('.custom-scroll.scroll-fancybox').customScroll();
					if (ps) ps.update();
				},
				reveal: (fancybox, slide) => {
					
				}
			}
		})	
	});
}

$("body").on("click", ".closePopUp", function(){
	const fancybox = Fancybox.getInstance();
	fancybox.close();
	return false;
});

document.addEventListener('DOMContentLoaded', function() {
    const fancyboxLinkNodes = document.getElementsByClassName('custom-fancybox');
    for(let i = 0; i < fancyboxLinkNodes.length; i++) {
        let fancyboxLinkNode = fancyboxLinkNodes.item(i);
        const customFancyboxObj = new customFancyboxInit(fancyboxLinkNode);
    }
	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});
});
